import { supabase } from '../lib/supabase';

let cache = { ts: 0, value: null };
const TTL_MS = 90_000;

/**
 * Agregaty zdobywców odznak (Supabase RPC `get_badge_unlock_counts`).
 * @returns {Promise<{ totalUsers: number, badges: Record<string, number> }>}
 */
export async function fetchBadgeUnlockCounts() {
  if (cache.value != null && Date.now() - cache.ts < TTL_MS) {
    return cache.value;
  }

  const { data, error } = await supabase.rpc('get_badge_unlock_counts');

  if (error || data == null) {
    const empty = { totalUsers: 0, badges: {} };
    cache = { ts: Date.now(), value: empty };
    return empty;
  }

  const totalUsers = typeof data.totalUsers === 'number' ? data.totalUsers : 0;
  const badges = data.badges && typeof data.badges === 'object' ? data.badges : {};
  const out = { totalUsers, badges };
  cache = { ts: Date.now(), value: out };
  return out;
}

/**
 * Klucz i18n dla etykiety rzadkości w populacji (udział kont z odznaką).
 */
export function populationRarityKey(count, totalUsers) {
  const c = Number(count);
  const t = Number(totalUsers);
  if (!Number.isFinite(t) || t < 1 || !Number.isFinite(c) || c < 0) {
    return 'badges.popRarity.unknown';
  }
  const pct = (c / t) * 100;
  if (pct < 1) return 'badges.popRarity.ultra';
  if (pct < 5) return 'badges.popRarity.veryRare';
  if (pct < 15) return 'badges.popRarity.rare';
  if (pct < 35) return 'badges.popRarity.fairlyCommon';
  return 'badges.popRarity.widespread';
}

export function formatUnlockPercent(count, totalUsers) {
  const c = Number(count);
  const t = Number(totalUsers);
  if (!Number.isFinite(t) || t < 1 || !Number.isFinite(c)) return null;
  return Math.round((c / t) * 1000) / 10;
}
